// DMK — currency selector dedupe
// Keeps only the first row per unique currency in the localization dropdown.
(function() {
  function dedupe(root) {
    const items = root.querySelectorAll('.localization-form__list-item[data-value]');
    const seen = new Set();
    items.forEach(li => {
      const cur = li.querySelector('.localization-form__currency');
      const key = cur ? cur.textContent.trim().replace(/\s+/g, ' ') : '';
      if (!key) return;
      if (seen.has(key)) {
        li.style.display = 'none';
      } else {
        seen.add(key);
      }
    });
  }
  function run() {
    document.querySelectorAll('localization-form-component, .localization-form__list').forEach(dedupe);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-run when the dropdown opens (list items may be added dynamically)
  const observer = new MutationObserver(() => run());
  observer.observe(document.body, { childList: true, subtree: true });
  // Also re-run periodically for a short window after load
  let tries = 0;
  const t = setInterval(() => { run(); if (++tries > 6) clearInterval(t); }, 500);
})();
